'use client';

import React from 'react';
import styles from './CustomDivider.module.scss';
import { Container } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';

const RightDivider = () => {
  useAOS();
  return (
    <Container className={styles.rightDivider}>
      <div className={styles.line} data-aos="slide-right" data-aos-easing="ease-in-out" />
    </Container>
  );
};

export default RightDivider;
